import "./AccountModal.scss";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../../../../store/authStore";
import { fetcher } from "../../../../utils/fetcher";
import Notification from "../../../Notification/Notification";

function AccountModal({ onClose }) {
  const user = useAuthStore((state) => state.user);
  const logout = useAuthStore((state) => state.logout);
  const navigate = useNavigate();
  const [notification, setNotification] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleCloseAccount = async () => {
    if (!showConfirm) {
      setShowConfirm(true);
      return;
    }

    setIsDeleting(true);
    try {
      await fetcher.post("/api/auth/close-account");

      // Log out and redirect to login
      logout();
      navigate("/login");
    } catch (error) {
      console.error("Close account error:", error);
      setNotification({
        message: `Failed to close account: ${error.message || "Please try again."}`,
        type: "error",
      });
      setIsDeleting(false);
      setShowConfirm(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    } catch (error) {
      return "N/A";
    }
  };

  return (
    <div className="account-modal-content">
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}
      <div className="title">
        <span>Account</span>
        <button className="close-button" onClick={onClose}>
          <span className="material-symbols-outlined">close</span>
        </button>
      </div>

      <div className="main-wrapper">
        <div className="account-info-section">
          <div className="info-group">
            <label>Email</label>
            <div className="info-value">{user?.email}</div>
          </div>

          <div className="info-group">
            <label>Subscription Status</label>
            <div className="info-value subscription-status">
              <span className="status-badge">
                {getSubscriptionLabel(user?.subscription)}
              </span>
            </div>
          </div>

          {user?.trialEndsAt && (
            <div className="info-group">
              <label>Trial Ends</label>
              <div className="info-value">{formatDate(user?.trialEndsAt)}</div>
            </div>
          )}
        </div>

        <div className="danger-zone">
          <h3>Be Aware</h3>
          <p>
            Closing your account will permanently delete all your data including
            organizations, projects, tasks, and notes. This action cannot be
            undone.
          </p>
          {showConfirm && (
            <p className="confirm-warning">
              ⚠️ Are you absolutely sure? Click again to confirm.
            </p>
          )}
          <button
            className="close-account-button"
            onClick={handleCloseAccount}
            disabled={isDeleting}
          >
            {isDeleting
              ? "Deleting Account..."
              : showConfirm
                ? "Click Again to Confirm"
                : "Close Account"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AccountModal;
